import * as ambassadorWixEcomV1ShippingOption from './ecom-v1-shipping-option-shipping-options.http.js';
import * as ambassadorWixEcomV1ShippingOptionTypes from './ecom-v1-shipping-option-shipping-options.types.js';
import * as ambassadorWixEcomV1ShippingOptionUniversalTypes from './ecom-v1-shipping-option-shipping-options.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createShippingOption(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1ShippingOptionUniversalTypes.CreateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.CreateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.CreateShippingOptionResponse,
  ambassadorWixEcomV1ShippingOptionTypes.CreateShippingOptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.createShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shipping-options',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getShippingOption(): __PublicMethodMetaInfo<
  'GET',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.GetShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.GetShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.GetShippingOptionResponse,
  ambassadorWixEcomV1ShippingOptionTypes.GetShippingOptionResponse
> {
  const payload = { shippingOptionId: ':shippingOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.getShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/shipping-options/{shippingOptionId}',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateShippingOption(): __PublicMethodMetaInfo<
  'PATCH',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateShippingOptionResponse,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateShippingOptionResponse
> {
  const payload = { shippingOption: { id: ':shippingOptionId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.updateShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/shipping-options/{shippingOption.id}',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteShippingOption(): __PublicMethodMetaInfo<
  'DELETE',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.DeleteShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.DeleteShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.DeleteShippingOptionResponse,
  ambassadorWixEcomV1ShippingOptionTypes.DeleteShippingOptionResponse
> {
  const payload = { shippingOptionId: ':shippingOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.deleteShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/shipping-options/{shippingOptionId}',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryShippingOptions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1ShippingOptionUniversalTypes.QueryShippingOptionsRequest,
  ambassadorWixEcomV1ShippingOptionTypes.QueryShippingOptionsRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.QueryShippingOptionsResponse,
  ambassadorWixEcomV1ShippingOptionTypes.QueryShippingOptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.queryShippingOptions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/shipping-options/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shipping-options/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.AddDeliveryRegionResponse,
  ambassadorWixEcomV1ShippingOptionTypes.AddDeliveryRegionResponse
> {
  const payload = { shippingOptionId: ':shippingOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.addDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shipping-options/{shippingOptionId}/add-delivery-region',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.RemoveDeliveryRegionResponse,
  ambassadorWixEcomV1ShippingOptionTypes.RemoveDeliveryRegionResponse
> {
  const payload = { shippingOptionId: ':shippingOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.removeDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shipping-options/{shippingOptionId}/remove-delivery-region',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ShippingOption as ShippingOptionOriginal,
  ConditionalRates as ConditionalRatesOriginal,
  Condition as ConditionOriginal,
  ConditionType as ConditionTypeOriginal,
  ConditionTypeWithLiterals as ConditionTypeWithLiteralsOriginal,
  LogicalOperator as LogicalOperatorOriginal,
  LogicalOperatorWithLiterals as LogicalOperatorWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateShippingOptionRequest as CreateShippingOptionRequestOriginal,
  CreateShippingOptionResponse as CreateShippingOptionResponseOriginal,
  GetShippingOptionRequest as GetShippingOptionRequestOriginal,
  GetShippingOptionResponse as GetShippingOptionResponseOriginal,
  UpdateShippingOptionRequest as UpdateShippingOptionRequestOriginal,
  UpdateShippingOptionResponse as UpdateShippingOptionResponseOriginal,
  DeleteShippingOptionRequest as DeleteShippingOptionRequestOriginal,
  DeleteShippingOptionResponse as DeleteShippingOptionResponseOriginal,
  QueryShippingOptionsRequest as QueryShippingOptionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryShippingOptionsResponse as QueryShippingOptionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  AddDeliveryRegionRequest as AddDeliveryRegionRequestOriginal,
  AddDeliveryRegionResponse as AddDeliveryRegionResponseOriginal,
  RemoveDeliveryRegionRequest as RemoveDeliveryRegionRequestOriginal,
  RemoveDeliveryRegionResponse as RemoveDeliveryRegionResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateShippingOptionApplicationErrors as CreateShippingOptionApplicationErrorsOriginal,
  UpdateShippingOptionApplicationErrors as UpdateShippingOptionApplicationErrorsOriginal,
} from './ecom-v1-shipping-option-shipping-options.types.js';
